<template>
  <svg
    width="22"
    height="21"
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22 0H0V20.9645H22V0Z" fill="white" fill-opacity="0.01" />
    <path
      d="M19.0206 10.4808C19.0206 6.13893 15.327 2.61914 10.7706 2.61914C9.65205 2.61914 8.58547 2.83128 7.61277 3.21563C7.11055 3.41408 6.63336 3.65844 6.18696 3.94321C5.73707 4.23022 5.31844 4.55828 4.937 4.92177C4.55556 5.28526 4.21129 5.68418 3.91011 6.1129M2.52063 10.4808C2.52063 14.8227 6.21428 18.3425 10.7706 18.3425C11.8892 18.3425 12.9558 18.1303 13.9285 17.746C14.4307 17.5475 14.9079 17.3032 15.3543 17.0184C15.8042 16.7314 16.2228 16.4033 16.6043 16.0399C16.9857 15.6764 17.33 15.2774 17.6312 14.8487"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.0207 3.49414V10.4823"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.52063 10.4805L2.52063 17.4686"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
